import { render, staticRenderFns } from "./video-elem.vue?vue&type=template&id=1248ceb4&scoped=true"
import script from "./video-elem.vue?vue&type=script&lang=js"
export * from "./video-elem.vue?vue&type=script&lang=js"
import style0 from "./video-elem.vue?vue&type=style&index=0&id=1248ceb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1248ceb4",
  null
  
)

export default component.exports